import React, { useState, useEffect } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useParams } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import "./InvoiceHistory.css";

export default function InvoiceHistory({ isSidebarExpanded }) {
  const { invoice_id } = useParams();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  useEffect(() => {
    fetchInvoices();
  }, []);

  useEffect(() => {
    if (invoices.length > 0) {
      const matchedInvoice =
        invoices.find((invoice) => invoice.invoice_id === invoice_id) ||
        invoices[0];
      setSelectedInvoice(matchedInvoice);
      fetchInvoiceHistory(matchedInvoice.invoice_id);
    }
  }, [invoices, invoice_id]);

  const fetchInvoices = async (status = "Active") => {
    try {
      const response = await axiosInstance.get(
        `/api/get_invoices?page_status=${status}`
      );
      setInvoices(response.data.data);
      setLoading(false);
    } catch (fetchError) {
      setError("only admins have access");
      setLoading(false);
    }
  };

  const fetchInvoiceHistory = async (id) => {
    setHistoryLoading(true);
    try {
      const response = await axiosInstance.get(`/api/history_invoice/${id}`);
      setInvoiceHistory(response.data.data || []);
    } catch (fetchError) {
      setHistoryError("only admins have access");
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleInvoiceClick = (invoice) => {
    setSelectedInvoice(invoice);
    fetchInvoiceHistory(invoice.invoice_id);
  };

  return (
    <div
      className={`invoice-container invoice-history-page ${
        isSidebarExpanded ? "expanded" : ""
      }`}
    >
      <div className="invoice-content">
        <div className="invoice-history-shell-header">
          <h2 className="invoice-header">Invoice History</h2>
          <p className="invoice-history-subtitle">
            Review invoice records and the related change timeline.
          </p>
        </div>

        <div className="invoice-grid">
          <div className="invoice-list">
            <div className="invoice-panel-header">Invoices</div>
            <div className="invoice-list-scroll">
              <table className="invoice-table">
                <thead>
                  <tr>
                    <th>Se. No</th>
                    <th>Invoice Number</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="2" className="center-text">
                        Loading...
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="2" className="error-text">
                        {error}
                      </td>
                    </tr>
                  ) : (
                    invoices.map((invoice, index) => (
                      <tr
                        key={invoice.invoice_id}
                        className={
                          selectedInvoice?.invoice_id === invoice.invoice_id
                            ? "selected-row"
                            : ""
                        }
                        onClick={() => handleInvoiceClick(invoice)}
                      >
                        <td>{index + 1}</td>
                        <td>{invoice.invoice_number}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {selectedInvoice && (
            <div className="invoice-history">
              <div className="history-header">
                <button
                  type="button"
                  className="history-back-button"
                  onClick={() => window.history.back()}
                >
                  <IoMdArrowBack className="icon-btn" />
                </button>
                <div className="history-header-copy">
                  <span className="history-panel-label">History Timeline</span>
                  <span className="invoice-name">
                    Invoice #{selectedInvoice.invoice_number} History
                  </span>
                </div>
              </div>

              <div className="history-content">
                {historyLoading ? (
                  <div className="center-text">Loading history...</div>
                ) : historyError ? (
                  <div className="error-text">{historyError}</div>
                ) : invoiceHistory.length > 0 ? (
                  invoiceHistory.map((historyItem, index) => (
                    <div key={index} className="history-item">
                      <div className="history-item-row">
                        <span className="history-item-label">Action Taken By</span>
                        <span className="history-item-value">
                          {historyItem.Changed_by}, {historyItem.user_role}
                        </span>
                      </div>
                      <div className="history-item-row">
                        <span className="history-item-label">Changed On</span>
                        <span className="history-item-value">
                          {new Date(historyItem.changed_on).toLocaleString()}
                        </span>
                      </div>
                      <div className="history-item-row">
                        <span className="history-item-label">Action</span>
                        <span className="history-item-value">{historyItem.action}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="center-text">No history available</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
